export default "__VITE_ASSET__D9jBx04C__"